export enum BillingOrderStatusType {
  Open = "Open",
  Delivered = "Delivered",
  Invoiced = "Invoiced",
  Sent = "Sent",
  Paid = "Paid",
  PaidManually = "PaidManually"
}
